import React from 'react';

import classNames from 'classnames';
import { Toast } from 'src/common/components';

import { BusinessPhone } from '../../types';
import { updateBusinessPhone } from '../api';
import { Action } from '../constants';
import { useAccountProfileContext } from '../context';

import BusinessPhoneCreateModal from './BusinessPhonesCreateModal';
import BusinessPhonesScheduleTestCallModal from './BusinessPhonesScheduleTestCallModal';

const BusinessPhones: React.FC = () => {
  const { state, dispatch } = useAccountProfileContext();
  const { account } = state;
  const { business_phones: businessPhones } = account;
  const isBusinessPhonesEmpty = businessPhones.length === 0;

  const handleSetIsEnabledForCallRescue =
    (businessPhone: BusinessPhone) => async (): Promise<void> => {
      try {
        await updateBusinessPhone(businessPhone.id, {
          is_enabled_for_call_rescue: !businessPhone.is_enabled_for_call_rescue,
        });
        dispatch({
          type: Action.UPDATE_BUSINESS_PHONE,
          id: businessPhone.id,
          is_enabled_for_call_rescue: !businessPhone.is_enabled_for_call_rescue,
        });
        Toast.success('The business phone new state was saved.');
      } catch {
        Toast.error('There was an error updating the business phone.');
      }
    };

  return (
    <div className="flex flex-col mt-6" data-testid="business-phones">
      <div className="flex ml-auto space-x-2">
        <BusinessPhonesScheduleTestCallModal />
        <BusinessPhoneCreateModal />
      </div>
      {isBusinessPhonesEmpty ? (
        <h3 className="sm:px-6 px-4 mx-auto mt-12" data-testid="empty-business-phones">
          Account currently has no business phones
        </h3>
      ) : (
        <>
          {businessPhones.map((businessPhone) => (
            <div
              className="flex border-b-2 border-white-1.0"
              key={businessPhone.id}
              data-testid={`business-phones-${businessPhone.id}`}
            >
              <div className="flex-grow">
                <div className="sm:grid sm:grid-cols-4 sm:px-6 px-4 py-5">
                  <h4 className="my-auto">Number</h4>
                  <p>{businessPhone.number}</p>
                </div>
                <div className="sm:grid sm:grid-cols-4 sm:px-6 px-4 pt-2 pb-4">
                  <div>
                    <h4 className="my-auto">Digits after call</h4>
                    <p className="helper-text"> Used to call extensions or IVR.</p>
                  </div>
                  <p>{businessPhone.digits_after_call || 'N/A'}</p>
                </div>
              </div>
              <button
                type="button"
                className="icon-btn my-auto ml-auto"
                data-testid="toggle-business-phone-btn"
                onClick={handleSetIsEnabledForCallRescue(businessPhone)}
              >
                <i
                  className={classNames(
                    'm-auto text-2xl text-primary-1.0',
                    businessPhone.is_enabled_for_call_rescue
                      ? 'icon-disable_icon'
                      : 'icon-activate_icon'
                  )}
                />
              </button>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default BusinessPhones;
